import { TipoPeriodoDescanso } from './enums/tipo-periodo-descanso.enum';

/** Constantes espelhadas de validacoes.service.ts (API). */
export const PERIODO_REGRAS_LIMITES = {
  minimoDiasLicencaPremio: 30,
  minimoDiasFerias: 5,
  maximoDiasFerias: 30,
  maximoDiasAbonoEspecial: 8,
  maximoDiasLicencaPremio: 90,
  idadeMaxima: 75,
  qtdeFracoesMaxima: 3,
  qtdeFracoesMaximaAbonoEspecial: 8,
} as const;

const {
  minimoDiasLicencaPremio,
  minimoDiasFerias,
  maximoDiasFerias,
  maximoDiasAbonoEspecial,
  maximoDiasLicencaPremio,
  idadeMaxima,
  qtdeFracoesMaxima,
  qtdeFracoesMaximaAbonoEspecial,
} = PERIODO_REGRAS_LIMITES;

const REGRAS_COMUNS = [
  'Não pode colidir com outro período (mesmo início/fim ou sobreposição de datas).',
  `O término do período não pode ultrapassar os ${idadeMaxima} anos de idade do defensor.`,
];

const REGRAS_POR_TIPO: Record<TipoPeriodoDescanso, string[]> = {
  [TipoPeriodoDescanso.Ferias]: [
    ...REGRAS_COMUNS,
    `Cada fração deve ter entre ${minimoDiasFerias} e ${maximoDiasFerias} dias.`,
    `O total de dias de férias no período aquisitivo não pode exceder ${maximoDiasFerias} dias.`,
    'O período aquisitivo deve ser um dos disponíveis (1 ano após admissão/referência).',
    `Máximo de ${qtdeFracoesMaxima} frações por período aquisitivo.`,
  ],
  [TipoPeriodoDescanso.FolgaNatalicia]: [
    ...REGRAS_COMUNS,
    'Deve ser de exatamente 1 dia (data inicial e final iguais).',
    'Deve ser no mês de aniversário do defensor.',
    'A referência é a data de nascimento do defensor.',
    'Apenas uma folga natalícia por ano civil (ano da data de gozo).',
  ],
  [TipoPeriodoDescanso.AbonoTrabalhado]: [...REGRAS_COMUNS],
  [TipoPeriodoDescanso.AbonoEspecial]: [
    ...REGRAS_COMUNS,
    `Máximo de ${maximoDiasAbonoEspecial} dias por ano (referência).`,
    `Máximo de ${qtdeFracoesMaximaAbonoEspecial} frações por ano.`,
  ],
  [TipoPeriodoDescanso.LicencaPremio]: [
    ...REGRAS_COMUNS,
    `Cada fração deve ter entre ${minimoDiasLicencaPremio} e ${maximoDiasLicencaPremio} dias.`,
    'O período aquisitivo deve ser um dos disponíveis (a cada 5 anos após admissão/referência).',
    `O total de dias no período aquisitivo não pode exceder ${maximoDiasLicencaPremio} dias.`,
    `Máximo de ${qtdeFracoesMaxima} frações por período aquisitivo.`,
  ],
  [TipoPeriodoDescanso.LicencaOutros]: [...REGRAS_COMUNS],
  [TipoPeriodoDescanso.Afastamento]: [...REGRAS_COMUNS],
};

/**
 * Retorna as regras de validação aplicáveis ao tipo de ação/evento.
 * Textos derivados de validacoes.service.ts (API).
 */
export function getRegrasExplicacaoPorTipo(tipo: TipoPeriodoDescanso): string[] {
  return REGRAS_POR_TIPO[tipo] ?? REGRAS_COMUNS;
}
